import {DataTable, date, name} from '@management-ui/core';
import {MTableToolbar} from '@material-table/core';
import {reverse} from 'named-urls';
import * as React from 'react';
import {useContext, useEffect, useMemo, useRef} from 'react';
import {useHistory} from 'react-router-dom';
import Filter from '../../../../components/Filter';
import {ServiceContext} from '../../../../components/Services';
import {useQuery, useTaskStatuses} from '../../../../hooks';
import routes from '../../../../routes';
import {API} from '../../../../services/API';
import TaskStatus from '../../../../components/TaskStatus';
import TaskPriority from '../../../../components/TaskPriority';
import {styled} from '@mui/material';

const Title = styled('span')(({theme}) => ({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  gap: theme.spacing(1),
}));

const Table = ({assignee = '', onUpdateUsers = () => null, archive}) => {
  const services = useContext(ServiceContext);
  const history = useHistory();
  const statuses = useTaskStatuses();

  /** @type {({current: DataTable})} */
  const tableRef = useRef();
  const refreshRef = useRef(JSON.stringify({status: 'pending', assignee: ''}));
  const {values: {status, page, pageSize}, changeQuery, changePage, initialised} = useQuery(useMemo(() => ({
    status: 'pending',
    page: '1',
    pageSize: '50',
    search: ''
  }), []));

  useEffect(() => {
    const key = JSON.stringify({status, assignee});
    if (initialised && refreshRef.current !== key && tableRef.current) {
      tableRef.current.refresh();
    }
    refreshRef.current = key;
  }, [status, assignee, initialised]);

  const tableProps = useMemo(() => ({
    tableProps: {
      components: {
        Toolbar: (props) => (
          <>
            <MTableToolbar {...props}/>
            <Filter
              statuses={statuses}
              status={status}
              onChangeStatus={changed => changeQuery({status: changed})}
            />
          </>
        )
      }
    },
    options: {
      initialPage: parseInt(page) - 1,
      pageSize: parseInt(pageSize),
      search: false
    },
    columns: [
      {title: 'Assignee', field: 'assignee', sorting: false, render: data => name(data.assignee)},
      {
        title: 'Title',
        field: 'title',
        render: data => <Title><TaskPriority task={data}/><span>{data.title}</span></Title>
      },
      {title: 'Deadline', field: 'deadline', render: data => date(data.deadline)},
      {
        title: 'Status',
        sorting: false,
        field: 'locked',
        render: item => <TaskStatus task={item}/>
      },
    ],
    loadData: query => new Promise((resolve, reject) => {
      changePage(API.getTableParams(query));
      const params = {status, assignee};
      if (archive) {
        params.archive = 'only';
      }
      services.task.getTableTasks(query, params)
        .then(response => {
          if (response.users) {
            onUpdateUsers(response.users);
          }
          resolve({
            data: response.data, page: response.meta.current_page - 1, totalCount: response.meta.total
          });
        }).catch(() => reject());
    }),
    onRowClick: (task) => history.push(reverse(task.archived ? routes.archive.task.detail : routes.tasks.detail, {id: task.id}))
  }), [archive, services, history, statuses, status, assignee, page, pageSize, changeQuery, changePage, onUpdateUsers]);

  return initialised ? (
    <>
      <DataTable
        ref={tableRef}
        title=""
        {...tableProps}
      />
    </>
  ) : null;
};

export default Table;
